import { US_STATES } from '../data/us-locations';

export const FIPS_TO_STATE = {
  '01': 'AL',
  '02': 'AK',
  '04': 'AZ',
  '05': 'AR',
  '06': 'CA',
  '08': 'CO',
  '09': 'CT',
  '10': 'DE',
  '11': 'DC',
  '12': 'FL',
  '13': 'GA',
  '15': 'HI',
  '16': 'ID',
  '17': 'IL',
  '18': 'IN',
  '19': 'IA',
  '20': 'KS',
  '21': 'KY',
  '22': 'LA',
  '23': 'ME',
  '24': 'MD',
  '25': 'MA',
  '26': 'MI',
  '27': 'MN',
  '28': 'MS',
  '29': 'MO',
  '30': 'MT',
  '31': 'NE',
  '32': 'NV',
  '33': 'NH',
  '34': 'NJ',
  '35': 'NM',
  '36': 'NY',
  '37': 'NC',
  '38': 'ND',
  '39': 'OH',
  '40': 'OK',
  '41': 'OR',
  '42': 'PA',
  '44': 'RI',
  '45': 'SC',
  '46': 'SD',
  '47': 'TN',
  '48': 'TX',
  '49': 'UT',
  '50': 'VT',
  '51': 'VA',
  '53': 'WA',
  '54': 'WV',
  '55': 'WI',
  '56': 'WY'
};

export const STATE_TO_FIPS = Object.fromEntries(
  Object.entries(FIPS_TO_STATE).map(([fips, code]) => [code, fips])
);

const STATE_NAME_TO_CODE = Object.fromEntries(
  US_STATES.map(({ code, name }) => [name, code])
);

export const getStateCodeFromGeo = (geo) => {
  const fips = String(geo.id ?? geo.properties?.id ?? '').padStart(2, '0');
  if (FIPS_TO_STATE[fips]) {
    return FIPS_TO_STATE[fips];
  }

  const name = geo.properties?.name;
  if (name && STATE_NAME_TO_CODE[name]) {
    return STATE_NAME_TO_CODE[name];
  }

  return null;
};

export const getStateName = (stateCode) =>
  US_STATES.find((state) => state.code === stateCode)?.name || stateCode;
